const DEFAULT_LEAVE_TYPES = new Set([
  'bereavement',
  'vacation',
  'military',
  'religious',
  'family',
  'pregnancy',
  'sick',
  'other'
]);

export const getConfiguredLeaveTypes = (
  orgLeaveTypes: { [k: string]: number } = {},
  userLeaveTypes?: { [k: string]: number },
  useCustomLeaveTypes?: boolean
) => {
  if (!useCustomLeaveTypes) {
    return { ...orgLeaveTypes };
  }

  return Object.entries(orgLeaveTypes).reduce((acc, [leaveType, defaultDays]) => {
    acc[leaveType] = userLeaveTypes?.[leaveType] ?? defaultDays;
    return acc;
  }, {} as { [k: string]: number });
};

export const localizeLeaveType = (
  translate: (key: string) => string,
  leaveType: string
) => {
  const translated = translate(leaveType);
  return translated === leaveType ? leaveType : translated;
};

export const isCustomLeaveType = (leaveType: string) =>
  !DEFAULT_LEAVE_TYPES.has(leaveType);
